import { render, staticRenderFns } from "./Liefer.vue?vue&type=template&id=70b984a6&"
import script from "./Liefer.vue?vue&type=script&lang=js&"
export * from "./Liefer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports